/* eslint-disable */
export default {
  dial: 'Marcar',
  message: 'Enviar mensagem',
  transfer: 'Transferir',
} as const;

// @key: @#@"dial"@#@ @source: @#@"Dial"@#@
// @key: @#@"message"@#@ @source: @#@"Message"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
